import axios from "axios";
import Unauthorized from "../errors/Unauthorized";
import NotFound from "../errors/NotFound";
import NetworkError from "../errors/NetworkError";
import BadRequest from "../errors/BadRequest";
import { logoutRedirect } from "../components/Authentication/RolePermission";
import Error500 from "../components/Authentication/errorPage/Error500/Error500";
import Error400 from "../components/Authentication/errorPage/Error400/Error400";
import { createRoot } from 'react-dom/client';


const API = axios.create({
  withCredentials: false,
  timeout: 500000,
});

API.interceptors.request.use((config) => {
  const authToken = localStorage.getItem("token");
  if (authToken) {
    config.headers.Authorization = `Bearer ${authToken}`;
  }
  return config;
});
const showErrorComponent = (Component) => {
  const rootElement = document.getElementById("root");
  const root = createRoot(rootElement); 
root.render(<Component />);
};
API.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response ? error.response.status : null;
    if (error.config.onModalClose) {
      error.config.onModalClose();  // Close the modal
    }
    switch (status) {
      case 400:
      case 500:
        // showErrorComponent(Error400);
        // break;
      case 401:
      case 403:
        logoutRedirect();
        throw new Unauthorized("The user session has expired");
      case 404:
        throw new NotFound("The APIDashboard is not found");
      case 502:
        throw new NetworkError("502 Bad Gateway Error");
      default:
        throw new NetworkError("An unknown error occurred");
    }
  }
);


export default API;
